import { RotateCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { DialogHeader, DialogTitle } from '@ui/dialog.tsx';
import { Button } from '@ui/button.tsx';

interface RenewalProgramIntroStepProps {
  onNext: () => void;
  onClose: () => void;
}

/**
 * Première étape du renouvellement : informe l'utilisateur que le programme touche à sa fin
 * et propose deux options : renouveler ou contacter l'équipe.
 */
export const RenewalProgramIntroStep = ({ onNext }: RenewalProgramIntroStepProps) => {
  const { t } = useTranslation();

  return (
    <>
      <DialogHeader>
        <DialogTitle className="text-2xl">{t('form.workspace.renewal.intro.title')}</DialogTitle>
      </DialogHeader>

      <div className="mt-6 space-y-6">
        <p className="text-sm leading-relaxed text-muted-foreground">
          {t('form.workspace.renewal.intro.paragraph1')}
        </p>

        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">
            {t('form.workspace.renewal.intro.paragraph2')}
          </p>

          <div className="space-y-3">
            <div className="space-y-2">
              <p className="text-sm font-medium text-foreground">
                {t('form.workspace.renewal.intro.option.keep_rules.title')}
              </p>
              <Button
                type="button"
                onClick={onNext}
                className="w-full text-white bg-purple-600 hover:bg-purple-700"
              >
                <RotateCw className="mr-2 w-4 h-4" />
                {t('form.workspace.renewal.intro.button.primary')}
              </Button>
            </div>

            <div className="space-y-2">
              <p className="text-sm text-muted-foreground">
                {t('form.workspace.renewal.intro.option.change_rules.help')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
